import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const HematologyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M80.2144 40C80.2144 61.8153 62.5296 79.5 40.7144 79.5C18.8991 79.5 1.21436 61.8153 1.21436 40C1.21436 18.1848 18.8991 0.5 40.7144 0.5C62.5296 0.5 80.2144 18.1848 80.2144 40Z'
    />
    <g clipPath='url(#clip0_414_8533)'>
      <path
        d='M51.702 50.6475L60.7153 59.6608L61.841 60.7865C62.8276 61.7731 62.8231 63.3835 61.8045 64.3376C61.3332 64.7793 60.73 65 60.1271 65C59.4989 65 58.8706 64.7604 58.3911 64.2813L57.2433 63.1331L48.23 54.1198L51.702 50.6475Z'
        fill='#5CAFE6'
      />
      <path
        d='M45.6654 32.6162C41.6836 23.2715 33.3721 15 33.3721 15C33.3721 15 19 29.3034 19 41.542C19 49.4795 25.4346 55.9141 33.3721 55.9141C34.1429 55.9141 34.8994 55.8535 35.6374 55.736H45.6654V32.6162Z'
        fill='#FF725C'
      />
      <path
        d='M42.6064 57.801C49.6632 57.801 55.3838 52.0804 55.3838 45.0237C55.3838 37.9669 49.6632 32.2463 42.6064 32.2463C35.5497 32.2463 29.8291 37.9669 29.8291 45.0237C29.8291 52.0804 35.5497 57.801 42.6064 57.801Z'
        fill='#66C2FF'
      />
      <path
        d='M42.6061 54.0587C47.5959 54.0587 51.641 50.0136 51.641 45.0238C51.641 40.034 47.5959 35.989 42.6061 35.989C37.6163 35.989 33.5713 40.034 33.5713 45.0238C33.5713 50.0136 37.6163 54.0587 42.6061 54.0587Z'
        fill='#E6F5FF'
      />
      <path
        d='M25.2785 48.507C25.1203 48.507 24.9637 48.4374 24.8576 48.3042C24.1079 47.3622 23.5239 46.3124 23.1219 45.1841C22.7059 44.0161 22.4946 42.7909 22.4946 41.5419C22.4946 38.5441 23.5838 34.9989 25.7323 31.0044C25.8729 30.743 26.1991 30.645 26.4604 30.7857C26.7218 30.9263 26.8198 31.2525 26.6792 31.5139C24.616 35.3501 23.5698 38.7238 23.5698 41.5419C23.5698 43.7775 24.3062 45.8843 25.6987 47.6346C25.8836 47.867 25.8452 48.2053 25.6128 48.3902C25.5138 48.4686 25.3957 48.507 25.2785 48.507Z'
        fill='#FFD2CC'
      />
      <path
        d='M44.6856 48.7305C46.2621 47.4543 46.8519 45.5696 46.003 44.521C45.1541 43.4723 43.1879 43.6568 41.6114 44.9331C40.0349 46.2093 39.445 48.094 40.2939 49.1426C41.1428 50.1913 43.109 50.0068 44.6856 48.7305Z'
        fill='#E66753'
      />
      <path
        d='M43.5733 45.1368C45.1498 43.8606 45.7396 41.9759 44.8907 40.9272C44.0418 39.8786 42.0756 40.0631 40.4991 41.3393C38.9226 42.6155 38.3327 44.5002 39.1816 45.5489C40.0305 46.5975 41.9967 46.413 43.5733 45.1368Z'
        fill='#FF725C'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_8533'>
        <rect width='50' height='50' fill='white' transform='translate(15.7144 15)' />
      </clipPath>
    </defs>
  </svg>
));
HematologyIcon.displayName = 'HematologyIcon';

export default HematologyIcon;
